import getConfig from 'next/config';
import type { ApiResponse, FetchHeaders, FetchOptions } from '@/interfaces';

const {
    publicRuntimeConfig: { hotelApiUrl },
    serverRuntimeConfig: { hotelApiUrl: internalHotelApiUrl },
} = getConfig();

const cookieHeader = (authCookies?: string): HeadersInit => {
    if (!authCookies) {
        return {};
    }
    return { cookie: authCookies };
};

const parseResponse = async <T>(res: Response, url: string, plain?: boolean): Promise<ApiResponse<T>> => {
    if (res.status >= 200 && res.status < 300) {
        return (plain ? res.text() : res.json()).then((data) => ({ status: res.status, data, url }));
    }
    return Promise.resolve({ status: res.status, url });
};

export const fetchFromApi = <T>(path: string, options: FetchOptions = {}): Promise<ApiResponse<T>> =>
    fetch((options.internal ? internalHotelApiUrl : hotelApiUrl) + path, {
        method: options.method ?? 'GET',
        headers: {
            Accept: 'application/json',
            ...(options.headers ?? {}),
            ...cookieHeader(options.authCookies),
        },
        signal: options.signal,
    })
        .then((res) => parseResponse<T>(res, path, options.plain))
        .catch((error) => ({ status: 500, url: path, error }));

export const postToApi = <T, B extends BodyInit>(
    path: string,
    body: B,
    headers: FetchHeaders = {},
    signal?: AbortSignal,
): Promise<ApiResponse<T>> =>
    fetch(hotelApiUrl + path, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            ...headers,
        },
        body,
        signal,
    })
        .then((res) => parseResponse<T>(res, path))
        .catch((error) => ({ status: 500, error, url: path }));
